import { render, staticRenderFns } from "./shortcutMenu.vue?vue&type=template&id=1ac9c706&scoped=true"
import script from "./shortcutMenu.vue?vue&type=script&lang=js"
export * from "./shortcutMenu.vue?vue&type=script&lang=js"
import style0 from "./shortcutMenu.vue?vue&type=style&index=0&id=1ac9c706&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac9c706",
  null
  
)

export default component.exports